import { useCallback } from 'react';
import useTracker from '@hooks/useTracker';

import {
  COLLAPSE_BOTTOM_PANEL,
  EXPAND_BOTTOM_PANEL,
  FULLSCREEN_BOTTOM_PANEL,
  SWITCH_BOTTOM_PANEL_ASSET,
  SWITCH_ACCOUNT_TYPE,
} from './constans';

/**
 * @typedef {object}  Tracker
 * @property  {Function}  eventExpandBottomPanel
 * @property  {Function}  eventSwitchBottomPanel
 * @property  {Function}  eventCollapseBottomPanel
 * @property  {Function}  eventFullScreenBottomPanel
 * @property  {Function}  eventSwitchAccountType
 */

function useEventTracker() {
  const { trackEvent } = useTracker();

  const eventExpandBottomPanel = useCallback(() => {
    trackEvent(EXPAND_BOTTOM_PANEL);
  }, []);

  const eventSwitchBottomPanel = useCallback(() => {
    trackEvent(SWITCH_BOTTOM_PANEL_ASSET);
  }, []);

  const eventCollapseBottomPanel = useCallback(() => {
    trackEvent(COLLAPSE_BOTTOM_PANEL);
  }, []);

  const eventFullScreenBottomPanel = useCallback(() => {
    trackEvent(FULLSCREEN_BOTTOM_PANEL);
  }, []);

  const eventSwitchAccountType = useCallback((accountType) => {
    trackEvent(SWITCH_ACCOUNT_TYPE, { account_type: accountType });
  }, []);

  return {
    eventSwitchBottomPanel,
    eventExpandBottomPanel,
    eventCollapseBottomPanel,
    eventFullScreenBottomPanel,
    eventSwitchAccountType,
  };
}

export default useEventTracker;
